enum TTSStatus {
  PLAYING = "playing",
  PAUSED = "paused",
  STOPPED = "stopped",
}

export default TTSStatus;
